import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface HelpLinkCardProps {
  to: string;
  icon: IconComponent;
  title: string;
  body: string;
  className?: string;
}

/** Dashed card that leads to a recovery or help path, e.g. "Can't sign in?" (Figma "Help link card"). */
const HelpLinkCard: React.FC<HelpLinkCardProps> = ({ to, icon, title, body, className }) => (
  <Link
    to={to}
    className={cn(
      'tw-group tw-flex tw-w-full tw-items-center tw-gap-[14px] tw-rounded-[14px] tw-border tw-border-dashed tw-border-ds-border-strong tw-bg-ds-surface tw-px-[18px] tw-py-4 tw-transition-colors',
      'hover:tw-border-ds-brand focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ds-brand',
      className,
    )}
  >
    <span className="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[10px] tw-bg-ds-brand-tint tw-text-ds-brand-text">
      <Icon icon={icon} size={20} />
    </span>
    <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
      <span className="tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-ds-text-primary">{title}</span>
      <span className="tw-text-[13px] tw-leading-[18px] tw-text-ds-text-secondary">{body}</span>
    </span>
    <Icon icon={ArrowRight} size={20} className="tw-text-ds-text-primary tw-transition-transform group-hover:tw-translate-x-0.5" />
  </Link>
);

export default HelpLinkCard;
